import { render, staticRenderFns } from "./common-parama.vue?vue&type=template&id=9c004618&scoped=true&"
import script from "./common-parama.vue?vue&type=script&lang=js&"
export * from "./common-parama.vue?vue&type=script&lang=js&"
import style0 from "./common-parama.vue?vue&type=style&index=0&id=9c004618&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c004618",
  null
  
)

export default component.exports